import React from "react";
import DashboardSettings from "./DashboardSettings";
import profileData from "../data/private/settings.profile.json";

export default function ProfileSetup() {
  return <DashboardSettings initialTabLabel={profileData.tabLabel} />;
}
